import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { Box, Text } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';
import ConfigBuilder, { getMacroKey } from '@nerdwallet/react-config-builder';
import CdsFiltersContext from '../../contexts/cds-filters-context/cds-filters-context';

import Row from '../row/row';
import {
  boolCheckboxSpec,
  stringInputSpec,
  stringTextAreaSpec,
} from '../../lib/editing-configs';
import { getValidationFn } from '../../lib/validations';

import formConfig from './form-config';
import './cds-filters.less';

const CdsFilters = ({ body, header, overlap }) => {
  const context = useContext(CdsFiltersContext);
  const { filters, setFilters } = context;

  const withConfigBasedValidation = (elConfig) => {
    const { validationType } = elConfig;
    const keyToValidate = _.get(elConfig.keys, '0.key');
    const validationFn = getValidationFn(validationType, keyToValidate);

    return {
      getValidationConfig: validationFn,

      // Explicitly defined fn gets precedent
      ...elConfig,
    };
  };

  const onChange = (config, value) => {
    const key = getMacroKey(config, 'value');
    setFilters({ ...filters, [key]: value });
  };

  return (
    <Row
      centeredInParent
      className={classNames('cds-filters', {
        'cds-filters__top-overlap': overlap,
      })}
    >
      <Box className="cds-filters-title">
        <Text component="h4" size="large">
          {header}
        </Text>
      </Box>
      <Box className={nds('padding-bottom-4', 'padding-bottom-3--wide')}>
        <Text>{body}</Text>
      </Box>
      <div
        className={nds(
          'display-flex',
          'flex-wrap',
          'justify-content-space-between',
          'padding-bottom-3'
        )}
      >
        {formConfig.map((elConfig) => (
          <ConfigBuilder
            data={filters}
            className={elConfig.viewType}
            viewConfig={withConfigBasedValidation(elConfig)}
            onChange={onChange}
            formName="cds-filter"
            key={elConfig.title}
          />
        ))}
      </div>
    </Row>
  );
};

CdsFilters.propTypes = {
  body: PropTypes.string,
  header: PropTypes.string,
  overlap: PropTypes.bool,
};

CdsFilters.defaultProps = {
  body: 'CD rates hinge on a few basic inputs, so be sure to enter your info below.',
  header: 'Get personalized rates',
  overlap: false,
};

CdsFilters.description =
  'This component should be used in conjunction with a CDs product table. You can update the default values of the filters on the corresponding CDs product table.';

CdsFilters.getEditingConfig = () => [
  stringInputSpec('header', 'Header'),
  stringTextAreaSpec('body', 'Body'),
  boolCheckboxSpec('overlap', 'Top overlap', {
    help: 'The top of tiles overlap with previous builder element.',
  }),
];

export default CdsFilters;
